import { initNav } from '../components/nav';

initNav();